import {Component, Input, Output, EventEmitter, OnInit, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageButtonComponent} from '../buttons/page-button.component';
import {ThemeService} from '../../services/theme-service';
import {ActivatedRoute, Router} from '@angular/router';
import {AppStateService} from '../../services/app-state.service';
import {Subscription} from 'rxjs';
import {BorderIconButtonComponent} from '../buttons/border-icon-button.component';
import {TranslateService} from '../../services/translate.service';
import {BottomSheetService} from '../../services/bottom-sheet.service';
import {WebCodeModalComponent} from '../dialogs/web-code-dialog.component';
import {ModalService} from '../../services/modal.service';
import {CallWaitressDialogComponent} from '../dialogs/call-waitress-dialog.component';
import {AuthService} from '../../services/auth.service';

@Component({
  standalone: true,
  imports: [CommonModule, PageButtonComponent, BorderIconButtonComponent],
  selector: 'app-venue-menu',
  template: `
    <div class="max-w-lg mx-auto bg-theme-surface-80 pb-safe w-full">
      <div class="flex flex-col gap-3 py-8">
        <app-border-icon-button *ngIf="noTable && !isKioskMode" icon="fa-location-dot" [text]="translate.getString('Välj Bord')" (onClick)="changeTable()"></app-border-icon-button>
        <app-border-icon-button *ngIf="!isKioskMode" icon="fa-wallet" [text]="translate.getString('Betala notan')" (onClick)="payBill()"></app-border-icon-button>
        <app-border-icon-button *ngIf="!noTable && !isKioskMode" icon="fa-location-dot" [text]="translate.getString('Byt Bord')" (onClick)="changeTable()"></app-border-icon-button>
        <app-border-icon-button icon="fa-hand-pointer" [text]="translate.getString('Kalla på servis')" (onClick)="callForWaitress()"></app-border-icon-button>

      </div>
    </div>
  `
})
export class VenueMenuComponent implements OnInit, OnDestroy {
  @Input() selectedPageId: string = '';
  @Output() onClick = new EventEmitter<MouseEvent>();
  private sub?: Subscription;
  noTable = true;
  isKioskMode = false;

  constructor(private themeService: ThemeService, private router: Router, private route: ActivatedRoute,
              private appStateService: AppStateService, protected translate: TranslateService,
              private sheetService: BottomSheetService, private modalService: ModalService,
              private auth: AuthService) {}

  ngOnInit(): void {
    this.isKioskMode = this.auth.isKioskMode();
    this.sub = this.appStateService.observeAppState().subscribe(appState => {
      // this.itemCount = MenuUtils.getItemCount(appState.order?.items);
      // const mustPay = appState.order?.user_cfg.payment?.open_order ?? true;
      // this.actionTitle = mustPay ? "Beställ och betala" : "Beställ";
      this.noTable = appState.order?.user_cfg?.table == null;
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  changeTable() {
    this.modalService.show(WebCodeModalComponent, {
      data: {}
    });
    this.sheetService.popSheet();
  }

  callForWaitress() {
    this.modalService.show(CallWaitressDialogComponent, {
      data: {
        title: 'Kalla på servis?',
        message: 'Personal kommer och hjälper dig.',
        confirmText: 'Bekräfta',
        abortText: 'Avbryt',
        action: 'callWaitress'
      }
    });
    this.sheetService.popSheet();
  }

  navLang() {

  }

  navButtonPreview() {
    this.router.navigate([this.appStateService.venueId, "button-preview"]);
    this.sheetService.popSheet();
  }

  payBill() {
    this.router.navigate([this.appStateService.venueId, "livesplit"]);
    this.sheetService.popSheet();
  }

  navSettlement() {
    this.router.navigate([this.appStateService.venueId, "settlement"]);
    this.sheetService.popSheet();
  }
}
